import { BsBank, BsBuilding, BsBuildings, BsCart, BsCircle, BsCircleFill, BsCone, BsConeStriped, BsDiamond, BsDiamondFill, BsDroplet, BsFire, BsFlag, BsFlagFill, BsGeo, BsGeoAlt, BsGeoAltFill, BsHexagon, BsHexagonFill, BsHospital, BsHouse, BsHouseDoor, BsHouses, BsPinMap, BsShop, BsShopWindow, BsSignStop, BsSignpost, BsSquare, BsSquareFill, BsStar, BsStarFill, BsTree, BsTreeFill, BsTriangle, BsTriangleFill, BsWater, } from 'react-icons/bs';
import { FaCross, FaGhost } from 'react-icons/fa6';
export const iconRegistry = {
    'bi bi-house': BsHouse,
    'bi bi-house-door': BsHouseDoor,
    'bi bi-houses': BsHouses,
    'bi bi-building': BsBuilding,
    'bi bi-buildings': BsBuildings,
    'bi bi-hospital': BsHospital,
    'bi bi-bank': BsBank,
    'bi bi-shop': BsShop,
    'bi bi-shop-window': BsShopWindow,
    'bi bi-cart': BsCart,
    'bi bi-tree': BsTree,
    'bi bi-tree-fill': BsTreeFill,
    'bi bi-water': BsWater,
    'bi bi-droplet': BsDroplet,
    'bi bi-fire': BsFire,
    'bi bi-geo-alt': BsGeoAlt,
    'bi bi-geo-alt-fill': BsGeoAltFill,
    'bi bi-geo': BsGeo,
    'bi bi-pin-map': BsPinMap,
    'bi bi-flag': BsFlag,
    'bi bi-flag-fill': BsFlagFill,
    'bi bi-star': BsStar,
    'bi bi-star-fill': BsStarFill,
    'bi bi-circle': BsCircle,
    'bi bi-circle-fill': BsCircleFill,
    'bi bi-square': BsSquare,
    'bi bi-square-fill': BsSquareFill,
    'bi bi-triangle': BsTriangle,
    'bi bi-triangle-fill': BsTriangleFill,
    'bi bi-hexagon': BsHexagon,
    'bi bi-hexagon-fill': BsHexagonFill,
    'bi bi-diamond': BsDiamond,
    'bi bi-diamond-fill': BsDiamondFill,
    'bi bi-signpost': BsSignpost,
    'bi bi-sign-stop': BsSignStop,
    'bi bi-cone': BsCone,
    'bi bi-cone-striped': BsConeStriped,
    'fa-solid fa-cross': FaCross,
    'fa-solid fa-ghost': FaGhost,
};
